<template>
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Gestión de Usuarios</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
              <li class="breadcrumb-item active">Administración</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

  <section class="content">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-12 col-sm-6 col-md-4">
          <div id="btn-agregar-usuario" class="info-box mb-3" @click="openForm()">
            <a href="javascript:void(0)" class="btn btn-block info-box-icon bg-success elevation-1">
              <i class="fas fa-user-plus"></i>
            </a>
            <div class="info-box-content">
              <span class="info-box-text">Usuario</span>
              <span class="info-box-number">Crear Nuevo</span>
            </div>
          </div>
        </div>
      </div>

      <div class="card shadow-sm card-outline card-primary">
        <div class="card-body table-responsive p-0">
      <table class="table table-hover table-valign-middle mb-0">
        <thead>
          <tr>
            <th>Nombre</th>
            <th class="d-none d-md-table-cell">Email</th>
            <th class="d-none d-md-table-cell">Rol</th>
            <th class="d-none d-lg-table-cell">Permisos</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.id">
            <td>{{ user.name }}</td>
            <td class="d-none d-md-table-cell">{{ user.email }}</td>
            <td class="d-none d-md-table-cell"><span v-for="role in user.roles" :key="role.id" class="badge-role">{{ role.name }}</span></td>
            <td class="d-none d-lg-table-cell">
              <span v-for="perm in user.permissions.slice(0, 3)" :key="perm.id" class="badge-perm">
                {{ perm.name }}
              </span>
              <span v-if="user.permissions.length > 3" class="badge-perm">...</span>
            </td>
            <td class="acciones-usuario">
              <div class="d-flex gap-2">
                <button @click="openForm(user)" class="btn btn-sm btn-primary btn-editar-tutorial"><i class="fas fa-edit"></i></button>
                <button @click="deleteUser(user.id)"  class="btn btn-sm btn-danger btn-eliminar-tutorial"><i class="fas fa-trash"></i></button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
        </div>
      </div>

    <!-- Formulario de Edición/Creación (Visible abajo) -->
    <section v-if="showForm" id="userFormSection" class="form-container mt-4 border rounded p-3 p-md-4 shadow-sm user-form-card">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h3>{{ isEditing ? 'Editar Usuario' : 'Crear Nuevo Usuario' }}</h3>
        <button type="button" class="btn btn-secondary btn-sm" @click="showForm = false">Cancelar</button>
      </div>
          <form @submit.prevent="saveUser">
              <div class="form-group">
            <label>Nombre Completo</label>
                <input v-model="form.name" ref="nameInput" required type="text" class="form-control" placeholder="John Doe" />
          </div>

              <div class="form-group">
                <label>Email</label>
                <input v-model="form.email" required type="email" class="form-control" placeholder="juan@ejemplo.com" />
              </div>

              <div class="form-group">
                <label>{{ isEditing ? 'Nueva Contraseña (dejar en blanco para no cambiar)' : 'Contraseña' }}</label>
                <input v-model="form.password" :required="!isEditing" type="password" class="form-control" placeholder="********" />
              </div>

              <div class="form-group">
                <label>Rol</label>
                <select v-model="form.role" class="form-control" required>
                  <option value="" disabled>Seleccione un rol</option>
                  <option v-for="role in roles" :key="role" :value="role">
                    {{ role }}
                  </option>
                </select>
              </div>

              <div class="form-group">
                <label>Permisos por Categoría</label>
                <div class="permission-categories border rounded">
                  <div v-for="(perms, category) in groupedPermissions" :key="category" class="category-item border-bottom border-secondary">
                    <div class="category-header p-2 d-flex justify-content-between align-items-center" style="cursor:pointer;" @click="toggleCategory(category)">
                      <span class="font-weight-bold text-uppercase small category-title">{{ category }}</span>
                      <div>
                        <span class="badge badge-info mr-2">{{ selectedInCategory(perms) }} / {{ perms.length }}</span>
                        <i :class="['fas', expandedCategory === category ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
                      </div>
                    </div>
                    
                    <div v-if="expandedCategory === category" class="category-details p-3 theme-inverted-details">
                      <div class="row">
                        <div v-for="perm in perms" :key="perm" class="col-md-6 mb-2 custom-control-container">
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" :id="perm" :value="perm" v-model="form.permissions">
                            <label class="custom-control-label font-weight-normal text-dark" :for="perm">
                              {{ perm.split('-').slice(0, -1).join(' ') || perm }} 
                              <small class="text-muted">({{ perm.split('-').pop() }})</small>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            <div class="form-actions d-flex justify-content-between mt-4">
              <button type="button" class="btn btn-danger" @click="deleteUser(currentUserId)" v-if="isEditing">Borrar</button>
              <div>
                <button type="submit" class="btn btn-success">Guardar</button>
              </div>
            </div>
          </form>
    </section>
    </div>
  </section>
</template>

<script setup>
import { ref, reactive, onMounted, onBeforeUnmount, computed, nextTick, getCurrentInstance } from 'vue';
import api from '../services/api';
import { tutorial } from "@/plugins/tutorial";
const { proxy } = getCurrentInstance();

const availablePermissions = ref([]);
const roles = ref([]);
const expandedCategory = ref(null);
const nameInput = ref(null);


const users = ref([]);

const showForm = ref(false);
const isEditing = ref(false);
const currentUserId = ref(null);

const form = reactive({
  name: '',
  email: '',
  password: '',
  role: '',
  permissions: []
});

const groupedPermissions = computed(() => {
  const groups = {};
  availablePermissions.value.forEach(perm => {
    // Extrae la base (ej: 'ventas' de 'ver-ventas' o 'crear-ventas')
    const parts = perm.split('-');
    const category = parts.length > 1 ? parts[1] : 'otros';
    if (!groups[category]) groups[category] = [];
    groups[category].push(perm);
  });
  return groups;
});

const toggleCategory = (category) => {
  expandedCategory.value = expandedCategory.value === category ? null : category;
};

const selectedInCategory = (perms) => {
  return perms.filter(p => form.permissions.includes(p)).length;
};

const fetchRolesAndPermissions = async () => {
  try {
    const { data } = await api.get('/roles-permisos');
    if (data) {
      roles.value = data.roles || [];
      availablePermissions.value = data.permissions || [];
      users.value = data.usuarios || [];
    }
  } catch (error) {
    console.error('Error cargando roles y permisos:', error);
  }
};

function iniciarTutorial() {
  const steps = [
    {
      element: '#btn-agregar-usuario',
      title: 'Nuevo Usuario',
      text: 'Haz clic aquí para registrar un nuevo usuario y asignarle roles y permisos.',
      position: 'bottom'
    },
    {
      element: '.table-responsive',
      title: 'Lista de Usuarios',
      text: 'Aquí puedes ver todos los usuarios registrados en el sistema.',
      position: 'top'
    },
    {
      element: '.btn-editar-tutorial',
      title: 'Editar Usuario',
      text: 'Usa este botón para modificar los datos, el rol o los permisos específicos de un usuario existente.',
      position: 'left'
    },
    {
      element: '.btn-eliminar-tutorial',
      title: 'Eliminar Usuario',
      text: 'Este botón permite dar de baja a un usuario del sistema. Se te pedirá una confirmación antes de proceder.',
      position: 'top'
    }
  ];
  tutorial.start(steps);
}

onMounted(async () => {
  try {
    await fetchRolesAndPermissions();
    tutorial.set(iniciarTutorial);
  } catch (error) {
    proxy.$toast({ icon: 'error', title: 'Error al cargar datos' });
  }
});

onBeforeUnmount(() => {
  tutorial.set(null);
});

const openForm = async (user = null) => {
  if (user) {
    isEditing.value = true;
    currentUserId.value = user.id;
    Object.assign(form, { 
      name: user.name, 
      email: user.email, 
      password: '',
      role: user.roles.length > 0 ? user.roles[0].name : '', 
      permissions: user.permissions.map(p => p.name) 
    });
  } else {
    isEditing.value = false;
    currentUserId.value = null;
    Object.assign(form, { name: '', email: '', password: '', role: '', permissions: [] });
  }
  showForm.value = true;

  await nextTick();
  // Scroll suave al formulario
  document.getElementById('userFormSection')?.scrollIntoView({ behavior: 'smooth' });
  // Hacer foco en el primer input
  if (nameInput.value) {
    nameInput.value.focus();
  }
};

const saveUser = async () => {
  try {
    // Clonamos el form para enviar el rol como un array
    const payload = { ...form, roles: [form.role] };
    if (isEditing.value) {
      await api.put(`/usuarios/${currentUserId.value}`, payload);
    } else {
      await api.post('/usuarios', payload);
    }
    await fetchRolesAndPermissions(); // Recargar lista
    showForm.value = false;
    proxy.$toast({ icon: 'success', title: 'Usuario guardado con éxito' });
  } catch (error) {
    console.error('Error al guardar usuario:', error);
    proxy.$toast({ icon: 'error', title: 'Error al guardar: ' + (error.response?.data?.message || error.message) });
  }
};

const deleteUser = async (id) => {
  if (!id) return;
  if (confirm('¿Estás seguro de que deseas eliminar este usuario?')) {
    try {
      await api.delete(`/usuarios/${id}`);
      users.value = users.value.filter(u => u.id !== id);
      if (currentUserId.value === id) showForm.value = false;
      proxy.$toast({ icon: 'success', title: 'Usuario eliminado' });
    } catch (error) {
      console.error('Error al eliminar:', error);
      proxy.$toast({ icon: 'error', title: 'No se pudo eliminar el usuario' });
    }
  }
};
</script>

<style scoped>
html { scroll-behavior: smooth; }
.admin-panel {
  font-family: sans-serif;
  color: #333;
}
.gap-2 { gap: 0.5rem; }
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}


th, td {
  padding: 1rem;
  border-bottom: 1px solid #eee;
}

.badge-role {
  background: #e3f2fd;
  color: #1976d2;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: bold;
}

.badge-perm {
  background: rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin-right: 4px;
  padding: 0.1rem 0.4rem;
  border-radius: 3px;
  font-size: 0.75rem;
}

/* Estilos adaptables para el formulario */
.user-form-card {
  background-color: #fff;
  color: #212529;
  border-color: #dee2e6 !important;
}

.category-header {
  background-color: #f8f9fa;
}

.category-details {
  background-color: #ffffff;
}

/* Adaptación a Dark Mode de AdminLTE */
[class*="dark-mode"] .user-form-card {
  background-color: #343a40 !important;
  color: #fff !important;
  border-color: #4b545c !important;
}

[class*="dark-mode"] .category-header {
  background-color: #3f474e !important;
  color: #fff;
}

[class*="dark-mode"] .category-details {
  background-color: #343a40;
}

/* Legacy styles */
[class*="dark-mode"] .badge-perm {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  color: #fff;
}

.modal-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100vh;
  background: rgba(0,0,0,0.5);
  display: flex; justify-content: center; align-items: center;
  z-index: 1050;
  padding: 10px;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label { display: block; margin-bottom: 0.5rem; font-weight: bold; }
.form-group input, .form-group select { width: 100%; padding: 0.5rem; border: 1px solid #ccc; border-radius: 4px; }

.permission-categories {
  border: 1px solid #ddd;
  border-radius: 4px;
  max-height: 300px;
  overflow-y: auto;
}

.category-item {
  border-bottom: 1px solid #eee;
}

.category-header {
  padding: 10px;
  background: #f8f9fa;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.category-header {
  align-items: center;
  justify-content: space-between;
}

.category-header:hover { background: #e9ecef; }

.category-name { font-weight: 600; font-size: 0.9rem; }

.badge-count {
  background: #6c757d;
  color: white;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 0.75rem;
}

.checkbox-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 12px;
  border: 1px solid #eee;
}

.checkbox-group label {
  font-weight: normal;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  padding: 4px;
  transition: background 0.2s;
}

.checkbox-group label:hover {
  background: #eef;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 1.5rem;
}
</style>